import React, { useEffect, useRef } from "react";
import { useField } from "@unform/core";

export default function Input({ label, name, ...rest }) {
	const inputRef = useRef(null);
	const { fieldName, defaultValue, registerField, error } = useField(name);

	useEffect(() => {
		registerField({
			name: fieldName,
			ref: inputRef.current,
			path: "value",
		});
	}, [fieldName, registerField]);

	return (
		<label>
			{label ? <p>{label}</p> : ""}
			<input ref={inputRef} defaultValue={defaultValue} {...rest} />
			{error && <span className='require'>{error}</span>}
			{ label === "Senha*" ? <h7 style={{ fontSize: "12px" }}>*A senha deve conter pelo menos 8 caracteres, sendo letra maiúscula, minúscula, número e símbolos.</h7> : <h7 style={{ display: "none" }}></h7>}
		</label>
	);
}
